import React from 'react';
import { Skeleton } from './skeleton';

interface TabsSkeletonProps {
  count?: number;
}

export const TabsSkeleton: React.FC<TabsSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="flex items-center border-b border-gray-200 animate-pulse">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="flex items-center gap-2 px-4 py-3">
          <Skeleton className="h-4 w-8" />
          <Skeleton className="h-4 w-6 rounded-full" />
        </div>
      ))}
    </div>
  );
};
